module.exports = __webpack_public_path__ + "img/play_big.33b3d5ff.png";